import { IAppReducerAction, IAppReducerOwnState } from "../shared/model";

const SET_ENVIRONMENTS = "SET_ENVIRONMENTS";
const SET_RULES = "SET_RULES";
const SET_SELECTED_RULE_ID = "SET_SELECTED_RULE_ID";

const SET_IS_LOADING = "SET_IS_LOADING";
const SET_IS_DIRTY = "SET_IS_DIRTY";
const SET_SAVE_BUTTON_CLICKED = "SET_SAVE_BUTTON_CLICKED";

const SET_SHOW_NEW_RULE_EDITOR = "SET_SHOW_NEW_RULE_EDITOR";
const SET_PROMOTED_VARIABLES = "SET_PROMOTED_VARIABLES";
const SET_SEARCH_STRING = "SET_SEARCH_STRING";
const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";
const SET_TIME_ZONES = "SET_TIME_ZONES";

const GET_ENVIRONMENTS = "GET_ENVIRONMENTS";
const GET_RULES = "GET_RULES";
const GET_IS_LOADING = "GET_IS_LOADING";
const GET_SHOW_NEW_RULE_EDITOR = "GET_SHOW_NEW_RULE_EDITOR";
const GET_PROMOTED_VARIABLES = "GET_PROMOTED_VARIABLES";
const GET_SEARCH_STRING = "GET_SEARCH_STRING";
const GET_USER_PERMISSIONS = "GET_USER_PERMISSIONS";
const GET_TIME_ZONES = "GET_TIME_ZONES";

export const initialState: IAppReducerOwnState = {
    environments: [],
    rules: null,
    selectedRuleId: null,
    isDirty: false,
    saveButtonClicked: false,
    isLoading: false,
    showNewRuleEditor: false,
    promotedVariables: [],
    searchString: "",
    userPermissions: {},
    timeZones: null
};

export function reducer(state: IAppReducerOwnState, action: IAppReducerAction): IAppReducerOwnState {
    switch (action.type) {
        case SET_ENVIRONMENTS:
            return {
                ...state,
                environments: action.environments
            };
        case SET_RULES:
            return {
                ...state,
                rules: action.rules
            };
        case SET_SELECTED_RULE_ID:
            return {
                ...state,
                selectedRuleId: action.id,
                isDirty: false
            };
        case SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            };
        case SET_IS_DIRTY:
            return {
                ...state,
                isDirty: action.isDirty
            };
        case SET_SAVE_BUTTON_CLICKED:
            return {
                ...state,
                saveButtonClicked: action.saveButtonClicked
            };
        case SET_SHOW_NEW_RULE_EDITOR:
            return {
                ...state,
                showNewRuleEditor: action.showNewRuleEditor
            };
        case SET_PROMOTED_VARIABLES:
            return {
                ...state,
                promotedVariables: action.promotedVariables
            };
        case SET_SEARCH_STRING:
            return {
                ...state,
                searchString: action.searchString
            };
        case SET_USER_PERMISSIONS:
            return {
                ...state,
                userPermissions: action.userPermissions
            };
        case SET_TIME_ZONES:
            return {
                ...state,
                timeZones: action.timeZones
            };
        case GET_ENVIRONMENTS:
            return {
                ...state,
                environments: state.environments
            };
        case GET_RULES:
            return {
                ...state,
                rules: state.rules
            };
        case GET_IS_LOADING:
            return {
                ...state,
                isLoading: state.isLoading
            };
        case GET_SHOW_NEW_RULE_EDITOR:
            return {
                ...state,
                showNewRuleEditor: state.showNewRuleEditor
            };
        case GET_PROMOTED_VARIABLES:
            return {
                ...state,
                promotedVariables: state.promotedVariables
            };
        case GET_SEARCH_STRING:
            return {
                ...state,
                searchString: state.searchString
            };
        case GET_USER_PERMISSIONS:
            return {
                ...state,
                userPermissions: state.userPermissions
            };
        case GET_TIME_ZONES:
            return {
                ...state,
                timeZones: state.timeZones
            };
        default:
            return initialState;
    }
}
